import { addUniqueItem, removeItem } from '@motionone/utils';
var scheduled = undefined;
function processScheduledAnimations() {
  if (!scheduled) return;
  var generators = scheduled.sort(compareByDepth).map(fireAnimateUpdates);
  generators.forEach(fireNext);
  generators.forEach(fireNext);
  scheduled = undefined;
}
function scheduleAnimation(state) {
  if (!scheduled) {
    scheduled = [state];
    requestAnimationFrame(processScheduledAnimations);
  } else {
    addUniqueItem(scheduled, state);
  }
}
function unscheduleAnimation(state) {
  scheduled && removeItem(scheduled, state);
}
var compareByDepth = function compareByDepth(a, b) {
  return a.getDepth() - b.getDepth();
};
var fireAnimateUpdates = function fireAnimateUpdates(state) {
  return state.animateUpdates();
};
var fireNext = function fireNext(iterator) {
  return iterator.next();
};
export { scheduleAnimation, unscheduleAnimation };